import { auth } from "application/auth/authReducer";
import { changeEmailConfirmation, changeEmailRequest } from "application/changeEmail/changeEmailReducer";
import { configSlice } from "application/config/configSlice";
import { customer } from "application/customer/customerReducer";
import { cutoff } from "application/cutoff/cutoffReducer";
import { deleteAccountConfirmation, deleteAccountRequest } from "application/deleteAccount/deleteAccountReducer";
import { delivery } from "application/delivery/deliveryReducer";
import { invoice } from "application/invoice/invoiceReducer";
import { locale } from "application/locale/localeReducer";
import { menu } from "application/menu/menuReducer";
import { merchandise } from "application/merchandise/merchandiseReducer";
import { monAlbumPhotoArchive } from "application/monAlbumPhotoArchive/monAlbumPhotoArchiveReducer";
import { ordersSlice } from "application/order/orderSlice";
import { reorder } from "application/reorder/reorderReducer";
import { projectsSlice } from "application/savedProjects/projectsSlice";
import { storage } from "application/storage/storageReducer";
import { pdf } from "application/unzipPdf/unzipPdfReducer";
import { widgetProducts } from "application/widget/widgetProductsReducer";
import { deleteWidget, shareWidgetEmail, widgets } from "application/widget/widgetReducer";
import { widgetGallerySlice } from "application/widgetGallery/widgetGallerySlice";
import { combineReducers } from "redux";

export const indexReducer = combineReducers({
  auth,
  operations: combineReducers({
    deleteAccountRequest,
    deleteAccountConfirmation,
    changeEmailRequest,
    changeEmailConfirmation,
    shareWidgetEmail,
    deleteWidget
  }),
  config: configSlice.reducer,
  customer,
  locale,
  orders: ordersSlice.reducer,
  merchandise,
  widgets,
  widgetProducts,
  storage,
  delivery,
  reorder,
  projects: projectsSlice.reducer,
  menu,
  monAlbumPhotoArchive,
  cutoff,
  invoice,
  pdf,
  widgetGallery: widgetGallerySlice.reducer
});
